export function updateRouteParams(path, oldParams, newParams = {}) {
  const params = { ...oldParams };
  for (const key of Object.keys(newParams)) {
    params[key] = newParams[key];
  }
  let pathWithParams = path;
  if (pathWithParams.length) {
    pathWithParams += '?';
  }
  const paramsKeys = Object.keys(params).filter(item => params[item]);
  for (let i = 0; i < paramsKeys.length; i++) {
    const key = paramsKeys[i];
    if (i !== 0) {
      pathWithParams += '&';
    }
    pathWithParams += `${key}=${encodeURIComponent(params[key])}`;
  }
  return pathWithParams;
}
